import React, { useId } from "react";
import { toast } from "react-toastify";

export default function DiscountInput({
  value = 0,
  price = 0,
  onChange,
  className = "",
  isDarkMode = false,
}) {
  const maximum = Math.max(0, Number(price) || 0);
  const inputId = useId();
  const isDisabled = Number(price) <= 0;
  return (
    <div
      className={`relative ${className} ${isDisabled ? "opacity-40 pointer-events-none grayscale" : ""}`}
      aria-disabled={isDisabled}
    >
      <div className="relative">
        <input
          id={inputId}
          type="number"
          min="0"
          max={maximum}
          step="0.01"
          value={value}
          placeholder=" "
          onChange={(event) => {
            if (isDisabled) return;
            const enteredValue = Math.max(0, Number(event.target.value));
            if (enteredValue > maximum) {
              onChange(maximum);
              toast.warning("Full price is the max discount", {
                toastId: "max-discount",
              });
              return;
            }
            onChange(enteredValue);
          }}
          disabled={isDisabled}
          className={`floating-input mt-2.5 w-full rounded-xl border px-3 py-3 text-sm outline-none [appearance:textfield] focus:border-blue-500 focus:ring-2 focus:ring-blue-100 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none ${
            isDarkMode
              ? "border-gray-500 bg-transparent text-white"
              : "border-gray-300 bg-white text-black"
          }`}
          aria-label="Discount amount"
        />
        <label htmlFor={inputId} className="floating-label">
          Discount Amount
        </label>
      </div>
    </div>
  );
}
